import { useTranslation } from 'react-i18next';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Tooltip,
    Snackbar,
    Alert,
} from '@mui/material';
import React, { useEffect, useState, useCallback } from 'react';
import 'react-circular-progressbar/dist/styles.css';
import Blur from '../Blur/Blur';
import { financeAPI } from '../../services/apiService';
import './progressBar.css';

const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

const toPersianNumber = (num) => {
    if (num == null) return '';
    const withCommas = Number(num).toLocaleString('en-US');
    return withCommas.replace(/\d/g, (d) => persianDigits[d]);
};

function ProgressBar({ totalOrdersCount = 0, totalOrdersPrice = 0 }) {
    const { t, i18n } = useTranslation();
    const token = localStorage.getItem('token');
    const group = localStorage.getItem('userGroup');
    const formatNumber = (num) => {
        if (num == null) return '';
        return new Intl.NumberFormat(i18n.language === 'fa' ? 'fa-IR' : 'en-US').format(num);
    };
    const [balance, setBalance] = useState(null);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [giftCode, setGiftCode] = useState('');
    const [error, setError] = useState(null);

    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    const data01 = [
        { name: 'Users', value: 20 },
        { name: 'Hotels', value: 20 },
        { name: 'Rooms', value: 20 },
        { name: 'Blogs', value: 20 },
        { name: 'Balance', value: 20 },
    ];

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setGiftCode('');
        setOpen(false);
    };

    const fetchBalance = useCallback(async () => {
        try {
            const result = await financeAPI.getBalance();
            setBalance(result.balance || 0);
        } catch (err) {
            console.error(err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    const handleGiftSubmit = async () => {
        if (!giftCode.trim()) return;

        try {
            await financeAPI.increaseBalance({ increase_token: giftCode });

            await fetchBalance();

            setSnackbar({
                open: true,
                message: t('gift_code_success'),
                severity: 'success',
            });
            handleClose();
        } catch (err) {
            console.error(err);
            setSnackbar({
                open: true,
                message: err.message || t('generic_error'),
                severity: 'error',
            });
        }
    };

    useEffect(() => {
        if (token && group) {
            fetchBalance();
        } else {
            setError(t('auth_error'));
            setLoading(false);
        }
    }, [token, group, fetchBalance, t]);

    return (
        <div className="progress_bar">
            <div className="top">
                <p>{t('daily_sales_analysis')}</p>
            </div>

            <div className="middle">
                <p>{t('today_invoices')}</p>
                <p className="price">{formatNumber(totalOrdersCount)}</p>

                <p>{t('today_sales') || 'Today Sales'}</p>
                <p className="price">
                    {formatNumber(totalOrdersPrice)} {t('toman')}
                </p>
            </div>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default ProgressBar;
